/* Arguments JSON : 
            "autocompleteArgs" :
                    "optionLocation": Sert à limiter la recherche à un/des type/s précis d'emplacement (par défaut ça sera ["street_address"] pour limiter aux adresses postales)
                    "countries" : Sert à limiter la recherche à un/des pays précis en usant de leur code/acronyme (par défaut France donc ["FR"]). INUTILE OVERRIDE PAR defaultCountry
            
            "gmapsArgs":
                    "typeMap" sert à gérer le visuel de la map. | Valeurs STRING possibles : "terrain", "hybrid", "satellite","roadmap"
                    "isTrafficEnabled" sert à activer la vision du traffic. | Valeurs BOOLEAN possibles: true, false
                    "optionOpenInGoogleMapActivated" sert à afficher le texte "Ouvrir dans Google map" dans le infoText du marker. | Valeurs BOOLEAN possibles: true, false
                    "displayMyLocationButton" sert à afficher le bouton permettant de se géolocaliser. | Valeurs BOOLEAN possibles: true, false
                    "displayWorkerLocationButton" sert à afficher le bouton permettant de géolocaliser l'intervenant. À associer avec l'ActionEvents "getWorkerCoords". | Valeurs BOOLEAN possibles: true, false
                    "displayStreetViewButton" sert à afficher le bouton permettant d'utiliser streetView. | Valeurs BOOLEAN possibles: true, false
                    "displayFullscreenButton" sert à afficher le bouton permettant de mettre l'affichage en fullscreen. | Valeurs BOOLEAN possibles: true, false
                    "displayChangeButton" sert à afficher le bouton permettant de changer de plan entre satellite et roadmap avec options permettant de choisir d'activer le relief (terrain) pour la roadmap et le nom des rues, les villes, etc...(hybrid) pour satellite. | Valeurs BOOLEAN possibles: true, false
                    "baseLocation" permet d'ajouter un marqueur sur la map qui sera automatiquement centré dessus. À ne pas associer avec "addressList". Valeur possible : une address sous format Json Stringigy
                    "addressList" permet d'ajouter plusieurs marqueurs sur la map et se centrer sur le dernier point. À ne pas associer avec "baseLocation".
                    "markerDraggable" permet de définir si le marqueur de preview est draggable ou non (en Édition uniquement) | Valeurs BOOLEAN possibles: true, false
                    
           "formArgs":
                    "displayAutocomplete" sert à afficher en mode édition l'autocomplete | Valeurs BOOLEAN possibles: true, false
                    "displayAddress" sert à afficher l'adresse | Valeurs BOOLEAN possibles: true, false *
                    "displayAddressPlus" sert à afficher l'adresse plus | Valeurs BOOLEAN possibles: true, false *
                    "displayAddressPlus2" sert à afficher l'address plus 2 | Valeurs BOOLEAN possibles: true, false *
                    "displayPC" sert à afficher le code postal | Valeurs BOOLEAN possibles: true, false *
                    "displayCity" sert à afficher la ville | Valeurs BOOLEAN possibles: true, false *
                    "displayCountry" sert à afficher le pays | Valeurs BOOLEAN possibles: true, false *
                    "displayMap" sert à afficher la map | Valeurs BOOLEAN possibles: true, false *
                    "displayLatLon" sert à afficher les coordonnées | Valeurs BOOLEAN possibles: true, false *
                    "displayGeocodeButton" sert à afficher le bouton servant à géocoder | Valeurs BOOLEAN possibles: true, false
                    "displaySearchPC" sert à afficher le bouton servant à rechercher le code postal depuis une api back | Valeurs BOOLEAN possibles: true, false
                    "displayGeocodeButton" sert à afficher le bouton servant à rechercher la ville depuis une api back | Valeurs BOOLEAN possibles: true, false

                    * veut dire que le champ en question permet de modifier en mode édit une info de l'address | Spécificité sur le displayMap, il doit être associé à markerDraggable = true pour modifier les coords

           "defaultCountry" sert à mettre un pays par défaut en sélection dans le menu de sélection de pays, OVERRIDE le countries de autocompleteArgs
           "canEdit" sert à choisir si on peut éditer ou non le formulaire d'adresse
                    
functionManager :
          "changeGeoAddress" sert à changer la geoAddress de l'objet address à retourner. Un booléan isManual sert à changer l'affichage selon l'état manuel de la saisie de la geoAddress ou non | Deux paramètres : geoAddress : objet GeoAddress et isManual : boolean
          "setValueAddress" sert à changer les champs du formulaire pour qu'ils s'acclimatent à l'objet address en paramètre et met à jour l'objet address de retour pour qu'il soit égal à celui en paramètre | Un paramètre : address : objet Address

*/


import { useState, useRef, useEffect } from 'react'
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import AutoAddressFrag from 'components/generic/AutoAddressFrag';
import GmapsFrag, { GeocodingAddress } from 'components/generic/GmapsFrag';
import { APIProvider, useMapsLibrary } from '@vis.gl/react-google-maps';
import countries from 'assets/countries-FR.json'

import * as commonFunc from 'scripts/common';

import {
    Label, Col, Progress, Input, FormFeedback
} from "reactstrap";

const mapsAPI_KEY = "AIzaSyCXONdJ6W5hndXH0ivRXCR3MbUMO4JXHdw";

// TODO Reparler avec Sébastien du paramétrage des sous-inputs
//TODO : AutoAddres et Gmaps ne peuvent pas être dans le même truc avec des clés différentes

function AddressUnit(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, getValues, setValue, errors } = formManager;

    const formArgs = data.argumentsObj?.formArgs || {};

    var subDataAutoAds = { bindPropResult: data.bindPropResult + ".cAutoAddress", objType: "autoAddress", arguments: data.argumentsObj?.autocompleteArgs, argumentsObj: data.argumentsObj?.autocompleteArgs };
    var subDataGmaps = { bindPropResult: data.bindPropResult + ".cGmaps", objType: "gmaps", arguments: data.argumentsObj?.gmapsArgs, argumentsObj: data.argumentsObj?.gmapsArgs, customDesign: { design: { boxSize: "1" } } };

    // Hooks React :
    // Input :
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [address3, setAddress3] = useState("");
    const [city, setCity] = useState("");
    const [pc, setPC] = useState("");
    const [country, setCountry] = useState(Object.keys(countries).find(i => countries[i] === (data.argumentsObj?.defaultCountry || 'FR')));
    const [lon, setLon] = useState("");
    const [lat, setLat] = useState("");
    // Sauvegarde :
    const addressRef = useRef(null);
    const lastGeoAddressGeocodedRef = useRef(null);
    const [searchingResultsPC, setSearchingResultsPC] = useState([]);
    const [searchingResultsCity, setSearchingResultsCity] = useState([]);
    // États :
    const [isSearchingPC, setIsSearchingPC] = useState(false);
    const [isSearchingCity, setIsSearchingCity] = useState(false);
    const [isManuallyChanged, setManuallyChanged] = useState(false);
    const [geocodeLaunched, setGeocodeLaunched] = useState(false);
    const [latLonReadOnly, setLatLonReadOnly] = useState(true);
    // Autres :
    const geocodingApiReload = useMapsLibrary("geocoding");
    const [geocodingService, setGeocodingService] = useState(null);

    const [shouldRender, setShouldRender] = useState(false);

    // Effects :
    useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data, args.trigger === "setValue" ? { value: (data.hasOwnProperty("defaultValue") ? data.defaultValue : "") } : null).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }
        if ((!data.children || data.children.length === 0) && modelFctManager?.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);

    useEffect(() => {
        if (!geocodingApiReload) return;
        setGeocodingService(new window.google.maps.Geocoder());
    }, [geocodingApiReload])

    // TODO changer les appels api
    useEffect(() => {
        if (!isSearchingPC) return;
        const args = {
            postalCode: pc,
        };
        closeAllDropdown();
        commonFunc.getMethod("../api/data/ValidatePostalCode", args).then((response) => {
            const noResultObject = {
                disabled: true
            };
            if (response.data) {
                if (response.data.isSuccess) {
                    if (isSearchingPC) {
                        setSearchingResultsPC(response.data.result)
                    }
                }
                else {
                    setSearchingResultsPC([noResultObject])
                }
            }
            else {
                setSearchingResultsPC([noResultObject])
            }
            setIsSearchingPC(false);
        });
    }, [isSearchingPC])

    useEffect(() => {
        if (!isSearchingCity) return
        const args = {
            city: city,
        };
        closeAllDropdown();
        commonFunc.getMethod("../api/research/city", args).then((response) => {
            const noResultObject = {
                disabled: true
            }
            if (response.data) {
                if (response.data.isSuccess) {
                    if (isSearchingCity) {
                        setSearchingResultsCity(response.data.result)
                    }
                }
                else {
                    setSearchingResultsCity([noResultObject])
                }
            }
            else {
                setSearchingResultsCity([noResultObject])
            }
            setIsSearchingCity(false);
        });
    }, [isSearchingCity])

    // Fonctions :
    // FunctionManager : 
    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };
    data.functionManager.changeGeoAddress = (geoAddress, isManual) => {
        //TODO : Check si besoin d'écraser l'ancien GeoAddress ou conservé les infos pour MAJ
        addressRef.current.geoAddress.geoLon = geoAddress.geoLon;
        addressRef.current.geoAddress.geoLat = geoAddress.geoLat;
        addressRef.current.geoAddress.geoSrc = geoAddress.geoSrc;
        addressRef.current.geoAddress.isManual = geoAddress.isManual;

        setLon(addressRef.current.geoAddress.geoLon);
        setLat(addressRef.current.geoAddress.geoLat);
        setManuallyChanged(isManual)
    }
    data.functionManager.setValue = (value, withRerender, src) => {
        var address = value;
        setAddress1(address.addressMain);
        setValue(bindPropResult + ".addressMain", address.addressMain);

        setAddress2((address.addressPlus) ? address.addressPlus : "");
        setValue(bindPropResult + ".addressPlus", address.addressPlus);

        setAddress3((address.addressPlus2) ? address.addressPlus2 : "");
        setValue(bindPropResult + ".addressPlus2", address.addressPlus2);

        //TODO
        setPTCAddress(address);
        setLon(address.geoAddress.geoLon)
        setLat(address.geoAddress.geoLat)
        if (address.type !== "Preview") address.type = "Preview";
        if (formArgs.displayMap && subDataGmaps?.functionManager?.addPoints) subDataGmaps.functionManager.addPoints([address]);

        //TODO : Conserver les ID ou tout viré ?
        const geoAddress = address.geoAddress;
        lastGeoAddressGeocodedRef.current = { ...geoAddress };
        addressRef.current = address;
        setLatLonReadOnly(false);
    }

    //TODO
    var defaultAddress = data.defaultValue || {};

    const { ref: refAddressMain, ...restAddressMain } = register(bindPropResult + ".addressMain", {
        value: (data.hasOwnProperty("defaultValue") ? defaultAddress.addressMain : ""),
        onChange: (e) => {
            setAddress1(e.target.value);
            if (addressRef.current?.geoAddress) resetGeoAddress();
        }
    });
    const { ref: refAddressPlus, ...restAddressPlus } = register(bindPropResult + ".addressPlus", {
        value: (data.hasOwnProperty("defaultValue") ? defaultAddress.addressPlus : ""),
        onChange: (e) => {
            setAddress2(e.target.value);
            if (addressRef.current?.geoAddress) resetGeoAddress();
        }
    });
    const { ref: refAddressPlus2, ...restAddressPlus2 } = register(bindPropResult + ".addressPlus2", {
        value: (data.hasOwnProperty("defaultValue") ? defaultAddress.addressPlus2 : ""),
        onChange: (e) => {
            setAddress3(e.target.value);
            if (addressRef.current?.geoAddress) resetGeoAddress();
        }
    });




    var disabled = (isConfiguration ? true : ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false)));
    if (disabled) {
        if (formArgs.displayMap && subDataGmaps?.functionManager?.setPreviewMarkerDraggable) subDataGmaps.functionManager.setPreviewMarkerDraggable(false);
    }

    // Internes :
    const closeAllDropdown = () => {
        if (searchingResultsPC) setSearchingResultsPC([])
        if (searchingResultsCity) setSearchingResultsCity([])
    }
    // PTC pour postal, city, country
    const setPTCAddress = (address) => {
        setPC(address.pc)
        setCity(address.city)
        if (!Object.values(countries).find(l => countries[address.country] === l)) {
            setCountry("Autres")
            address.country = "Autres";
        }
        else {
            setCountry(address.country)
        }
    }
    // fonction se lancant lorsque l'utilisateur appuie sur le bouton lancer le géocodage
    const onSubmitHandle = (e) => {
        //e.preventDefault();
        closeAllDropdown();
        setGeocodeLaunched(true);
        setManuallyChanged(false);
        if (formArgs.displayMap && subDataGmaps?.functionManager?.setPreviewMarkerDraggable) subDataGmaps.functionManager.setPreviewMarkerDraggable(false);
        const newAddress = {
            addressMain: address1,
            city: city,
            pc: pc,
            country: country,
            addressPlus: address2 + address3,
            type: "Preview"
        }
        GeocodingAddress(newAddress, geocodingService).then((geoAddress) => {
            newAddress.geoAddress = geoAddress;
            data.functionManager.setValue(newAddress);
            if (formArgs.displayMap && subDataGmaps?.functionManager?.setPreviewMarkerDraggable) subDataGmaps.functionManager.setPreviewMarkerDraggable(data.argumentsObj?.gmapsArgs?.markerDraggable ? true : false)
            setGeocodeLaunched(false)
        })
    }

    const onChangeLatLon = (value, latOrLon) => {
        if (!value) return;
        if (lat && lon && addressRef.current) {
            addressRef.current.geoAddress.geoSrc = "manual";
            addressRef.current.geoAddress.isManual = true;
            switch (latOrLon) {
                case "lat": {
                    addressRef.current.geoAddress.geoLat = value;
                    setLat(value)
                    break;
                }
                case "lon": {
                    addressRef.current.geoAddress.geoLon = value;
                    setLon(value)
                    break;
                }
                case "both": {
                    addressRef.current.geoAddress.geoLon = value.geoLon;
                    addressRef.current.geoAddress.geoLat = value.geoLat;
                    setLon(value.geoLon)
                    setLat(value.geoLat)
                    break;
                }
                default:
                    break;
            }
            setManuallyChanged(true)
            if (formArgs.displayMap && subDataGmaps?.functionManager?.addPoints) subDataGmaps.functionManager.addPoints([addressRef.current])

        }
    }

    const resetManualGeoAddress = () => {
        data.functionManager.changeGeoAddress(lastGeoAddressGeocodedRef.current, false);
        if (lat && lon && addressRef.current && formArgs.displayMap && subDataGmaps?.functionManager?.addPoints) subDataGmaps.functionManager.addPoints([addressRef.current])
    }
    const resetGeoAddress = () => {
        if (!addressRef?.current) return
        addressRef.geoAddress = null;
        setLon("");
        setLat("");
        if (formArgs.displayMap && subDataGmaps?.functionManager?.deletePreviewMarker) subDataGmaps.functionManager.deletePreviewMarker()
    }


    const manageDesignInput = (designInput, inputStyle, inputClass) => {
        designInput = modelFctManager.prepareMergedDesign(data, designInput, "default_addressUnitInput", true);
        if (designInput) {
            if (designInput.boxSize) {
                //widthClass += " w-" + parseInt(parseFloat(designInput.boxSize) * 100);
                //widthClass += modelFctManager.convertWidthToGrid(parseFloat(designInput.boxSize) * 100);
                inputClass += modelFctManager.convertWidthToGrid(parseFloat(designInput.boxSize) * 100);
            }


            Object.assign(inputStyle, modelFctManager.setCustomBackground(designInput, data));
            //Object.assign(inputStyle, modelFctManager.managePadding(designInput, inputClass));
            Object.assign(inputStyle, modelFctManager.manageMargin(designInput, inputClass));


            //TODO : icon

            if (designInput.size || designInput.width) mainStyle.width = (designInput.size ? (designInput.size + "px") : designInput.width);
            if (designInput.height) mainStyle.height = designInput.height;

            if (designInput.fontColor) mainStyle.color = modelFctManager.getRgbaFromHex(designInput.fontColor);
            if (designInput.fontSize) mainStyle.fontSize = designInput.fontSize;
            if (designInput.fontStyle) {
                if (designInput.fontStyle.indexOf("bold") >= 0) mainStyle.fontWeight = "bold";
                if (designInput.fontStyle.indexOf("italic") >= 0) mainStyle.fontStyle = "italic";
            }

            if (designInput.alignment) {//TODO : TO CHECK
                var split = designInput.alignment.split("|");
                split.forEach((part) => {
                    inputClass += " text-" + part.replace("left", "start").replace("right", "end");
                    inputClass = inputClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
                });
            }

        }
    };


    var extrasDesign = data.customDesign?.extrasDesign;

    var mainStyle = {}, mainClass = "";
    var plusStyle = {}, plusClass = "";
    var plus2Style = {}, plus2Class = "";
    if (extrasDesign) {
        if (extrasDesign.mainAddress) manageDesignInput(extrasDesign.mainAddress, mainStyle, mainClass);
        if (extrasDesign.plusAddress) manageDesignInput(extrasDesign.plusAddress, plusStyle, plusClass);
        if (extrasDesign.plus2Address) manageDesignInput(extrasDesign.plus2Address, plus2Style, plus2Class);
        //TODO
    }


    var mainError = commonFunc.getValue(errors, bindPropResult + ".addressMain");
    var plusError = commonFunc.getValue(errors, bindPropResult + ".addressPlus");
    var plus2Error = commonFunc.getValue(errors, bindPropResult + ".addressPlus2");
    //var mainError = commonFunc.getValue(errors, bindPropResult);
    //TODO

    return (<>
            {disabled ? (
                <>
                    <div className="bg-light rounded p-4 mb-3">
                        <h5 className="fw-bold text-dark">Adresse</h5>
                    {((formArgs.displayAddress && !address1) || (formArgs.displayPC & !pc) || (formArgs.displayCity && !city) || (formArgs.displayCountry && !country)) ?
                            <div className="mt-3">
                                <i className="bi bi-geo-alt text-muted me-2"></i>
                                <span className="fw-semibold">Aucune adresse renseignée !</span>
                            </div>
                            :
                            <>
                                {address1 && <div className="mt-3">
                                    <div>
                                        <i className="bi bi-geo-alt text-muted me-2"></i>
                                        <span className="fw-semibold">{address1 || ""}</span>
                                    </div>
                                    {address2 && (
                                        <div className="text-muted ms-4">{address2}</div>
                                    )}
                                    {address3 && (
                                        <div className="text-muted ms-4">{address3}</div>
                                    )}
                                </div>}

                                {(pc || city) && <div className="mt-2">
                                    <i className="bi bi-mailbox2 text-muted me-2"></i>
                                    <span>{pc || ""} {city || ""}</span>
                                </div>}
                                {country && <div className="mt-2">
                                    <i className="bi bi-globe2 text-muted me-2"></i>
                                    <span>{country || ""}</span>
                                </div>}
                            </>}
                    </div>
                </>
            ) : (
                <>
                    <form onSubmit={onSubmitHandle} action="" method="POST">
                        <div className="flex-grow-1 bg-light rounded p-3 mb-3">
                            {(formArgs.displayAddress || formArgs.displayAutocomplete) &&
                                <div className="d-flex flex-column gap-3 mb-3">
                                    {formArgs?.displayAutocomplete &&
                                        <div className="d-flex flex-column">
                                            <label htmlFor="research" className="form-label fw-semibold text-secondary">
                                                Recherche :
                                            </label>
                                            <AutoAddressFrag {...props} key={(bindPropResult + country)} data={subDataAutoAds} bindPropResult={commonFunc.camelize(subDataAutoAds.bindPropResult, true)}
                                                defaultCountry={countries[country]} setValueAddress={data.functionManager.setValue} />
                                        </div>
                                    }
                                    {formArgs.displayAddress &&
                                        <div className="d-flex flex-column">
                                            <label htmlFor={"address1" + bindPropResult} className="form-label fw-semibold text-secondary">
                                                Adresse :
                                            </label>
                                            <Input id={"address1" + bindPropResult} type="text" disabled={disabled || geocodeLaunched} className={`${mainClass}`} style={mainStyle} autocomplete="off" aria-autocomplete="none"
                                                innerRef={refAddressMain} {...restAddressMain} invalid={mainError ? true : false}></Input>
                                            <FormFeedback className={`text-start ${mainError ? "d-block" : ""}`}>{mainError ? mainError.message : t("gal_reqFields")}</FormFeedback>
                                        </div>
                                    }
                                    {formArgs.displayAddressPlus &&
                                        <div className="d-flex flex-column">
                                            <label htmlFor={"address2" + bindPropResult} className="form-label fw-semibold text-secondary">
                                                Adresse 2 :
                                            </label>
                                            <Input id={"address2" + bindPropResult} type="text" disabled={disabled || geocodeLaunched} className={`${plusClass}`} style={plusStyle} autocomplete="off" aria-autocomplete="none"
                                                innerRef={refAddressPlus} {...restAddressPlus} invalid={plusError ? true : false}></Input>
                                            <FormFeedback className={`text-start ${plusError ? "d-block" : ""}`}>{plusError ? plusError.message : t("gal_reqFields")}</FormFeedback>
                                        </div>
                                    }
                                    {formArgs.displayAddressPlus2 &&
                                        <div className="d-flex flex-column">
                                            <label htmlFor={"address3" + bindPropResult} className="form-label fw-semibold text-secondary">
                                                Adresse 3 :
                                            </label>
                                            <Input id={"address3" + bindPropResult} type="text" disabled={disabled || geocodeLaunched} className={`${plus2Class}`} style={plus2Style} autocomplete="off" aria-autocomplete="none"
                                                innerRef={refAddressPlus2} {...restAddressPlus2} invalid={plus2Error ? true : false}></Input>
                                            <FormFeedback className={`text-start ${plus2Error ? "d-block" : ""}`}>{plus2Error ? plus2Error.message : t("gal_reqFields")}</FormFeedback>
                                        </div>
                                    }
                                </div>
                            }
                            {(formArgs.displayPC || formArgs.displayCity) &&
                                <div className="d-flex flex-wrap gap-3">
                                    {formArgs.displayPC &&
                                        <div className="d-flex flex-column flex-fill">
                                            <label htmlFor="pc" className="form-label fw-semibold text-secondary">Code postal :</label>
                                            <div className="position-relative dropdown">
                                                {/* Ne pas oublier de metttre minLength 2 pour le code postal */}
                                                <input autocomplete="off" onBlur={() => { setSearchingResultsPC([]) }} id="pc" minLength="2" data-bs-toggle="dropdown" type="text" className="form-control pe-5" value={pc} onChange={(e) => { setPC(e.target.value) }} required disabled={geocodeLaunched}></input>
                                                {formArgs.displaySearchPC ?
                                                    <>
                                                        {searchingResultsPC.length > 0 ? <button type="button"
                                                                className="btn btn-link position-absolute top-50 end-0 translate-middle-y me-2 p-0 text-secondary"
                                                                onClick={() => { setSearchingResultsPC([]) }}
                                                            ><i className="fa fa-x-mark"></i></button>
                                                            :
                                                            <button type="button" className="btn btn-link position-absolute top-50 end-0 translate-middle-y me-2 p-0 text-secondary search-address-component"
                                                                onClick={() => { setIsSearchingPC(!isSearchingPC) }} disabled={disabled || geocodeLaunched || isSearchingCity} >
                                                                {!isSearchingPC ? <i className="fa fa-magnifying-glass"></i> :
                                                                    <>
                                                                        <i className="fa fa-circle-notch fa-spin"></i>
                                                                        <i className="fa fa-x-mark icon-hover"></i>
                                                                    </>
                                                                }
                                                            </button>
                                                        }
                                                        <div onBlur={() => { setSearchingResultsPC([]) }} className={`dropdown-menu w-100 ${(searchingResultsPC.length > 0) ? "show" : ""}`}>
                                                            {searchingResultsPC.map((result, index) => {
                                                                if (result.disabled) {
                                                                    return (<button type="button" className="dropdown-item" disabled >Aucun résultat disponible</button>)
                                                                }
                                                                else {
                                                                    return (<button type="button" className="dropdown-item" onClick={() => { setPTCAddress(result); closeAllDropdown(); }}>{result.pc} - {result.city}</button>)
                                                                }
                                                            })}
                                                        </div>
                                                    </> : <div onBlur={() => { setSearchingResultsPC([]) }} className={`dropdown-menu w-100`}></div>
                                                }
                                            </div>
                                        </div>
                                    }
                                    {formArgs.displayCity &&
                                        <div className="d-flex flex-column flex-fill">
                                            <label htmlFor="city" className="form-label fw-semibold text-secondary">Ville :</label>
                                            <div className="position-relative dropdown">
                                                <input autocomplete="off" id="city" type="text" data-bs-toggle="dropdown" className="form-control" value={city} onChange={(e) => { setCity(e.target.value) }} required disabled={geocodeLaunched}></input>
                                                {formArgs.displaySearchCity ?
                                                    <>
                                                        {searchingResultsCity.length > 0 ? <button type="button"
                                                                className="btn btn-link position-absolute top-50 end-0 translate-middle-y me-2 p-0 text-secondary"
                                                                onClick={() => { setSearchingResultsCity([]) }}
                                                            ><i className="fa fa-x-mark"></i></button>
                                                            : 
                                                            <button type="button" className="btn btn-link position-absolute top-50 end-0 translate-middle-y me-2 p-0 text-secondary search-address-component"
                                                                onClick={() => { setIsSearchingCity(!isSearchingCity) }} disabled={disabled || geocodeLaunched || isSearchingPC}>
                                                                {!isSearchingCity ? <i className="fa fa-magnifying-glass"></i> :
                                                                    <>
                                                                        <i className="fa fa-circle-notch fa-spin"></i>
                                                                        <i className="fa fa-x-mark icon-hover"></i>
                                                                    </>
                                                                }
                                                            </button>
                                                        }
                                                        <div className={`dropdown-menu w-100 ${(searchingResultsCity.length > 0) ? "show" : ""}`}>
                                                            {searchingResultsCity.map((result, index) => {
                                                                if (result.disabled) {
                                                                    return (<button type="button" className="dropdown-item" disabled >Aucun résultat disponible</button>)
                                                                }
                                                                else {
                                                                    return (<button type="button" className="dropdown-item" onClick={() => { setPTCAddress(result); closeAllDropdown(); }}>{result.pc} - {result.city}</button>)
                                                                }
                                                            })}
                                                        </div>
                                                    </> : <div onBlur={() => { setSearchingResultsPC([]) }} className={`dropdown-menu w-100`}></div>
                                                }
                                            </div>

                                        </div>
                                    }
                                </div>
                            }
                            {formArgs.displayCountry &&
                                <div className="d-flex flex-column gap-3 mb-3 mt-3">
                                    <div className="d-flex flex-column">
                                        <label htmlFor="country" className="form-label fw-semibold text-secondary">
                                            Pays :
                                        </label>
                                        <div className="position-relative">
                                            <select className="form-select" value={country} onFocus={(e) => { e.target.size = 5 }} onBlur={(e) => { e.target.size = 1 }} onChange={(e) => { setCountry(e.target.value); e.target.blur() }} disabled={disabled || geocodeLaunched || isSearchingPC || isSearchingCity} >
                                                {Object.entries(countries).map(([code, name]) => {
                                                    return (<option key={name} value={code} className="" onClick={() => { setCountry(code); }}>{code}</option>)
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            }
                            {formArgs.displayGeocodeButton &&
                                <div className="d-flex flex-column gap-3 mb-3 mt-3">
                                    <div className="d-flex flex-column">
                                        <button type="button" className="btn btn-dark" disabled={disabled || geocodeLaunched} onClick={(e) => { onSubmitHandle(e); }}>{geocodeLaunched ? <i className="fa fa-ellipsis fa-fade"></i> : "Lancer le géocodage"}</button>
                                    </div>
                                </div>
                            }
                        </div>
                    </form>
                </>
            )}
            {(formArgs.displayMap || formArgs.displayLatLon) &&
                <div className="bg-dark text-white text-center p-3 rounded">
                {formArgs.displayMap && <GmapsFrag {...props} key={bindPropResult + "maps"} data={subDataGmaps} bindPropResult={commonFunc.camelize(subDataAutoAds.bindPropResult, true)} changeGeoAddress={data.functionManager.changeGeoAddress}></GmapsFrag>}
                {(isManuallyChanged && !disabled) && <button className="mt-3 btn btn-danger" onClick={() => { resetManualGeoAddress() }}> Retour à la localisation par défaut </button>}
                {formArgs.displayLatLon &&
                        <div className="d-flex mt-3 flex-wrap gap-3">
                            <div className="d-flex flex-column flex-fill">
                                <label htmlFor="lat" className="form-label fw-semibold text-white">
                                    Latitute :
                                </label>
                                <input autocomplete="off" id="lat" type="number" step="any" className="form-control" value={lat} onChange={(e) => { onChangeLatLon(parseFloat(e.target.value), "lat") }} readOnly={latLonReadOnly} disabled={disabled || geocodeLaunched}></input>
                            </div>
                            <div className="d-flex flex-column flex-fill">
                                <label htmlFor="lon" className="form-label fw-semibold text-white">
                                    Longitude :
                                </label>
                                <input autocomplete="off" id="lon" type="number" step="any" className="form-control" value={lon} onChange={(e) => { onChangeLatLon(parseFloat(e.target.value), "lon") }} readOnly={latLonReadOnly} disabled={disabled || geocodeLaunched}></input>
                            </div>
                        </div>
                    }
                </div>
            }
        </>

        // TODO ajouter un champ de recherche en dessous de code postal et Ville avec dans l'input autocomplete="off"une loupe, click = ouverture
    );
}


export default function AddressUnitFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;


    var frameClass = "d-inline-block mb-3";
    var frameStyle = {};
    var containerClass = "";
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var formClass = "form-group m-0 ";
    //TODO : design
    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_addressUnit");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            //frameClass += " w-" + parseInt(parseFloat(design.boxSize) * 100);
            //titleClass += " w-100";
            var supBoxSize = modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
            frameClass += supBoxSize;
            //titleClass += modelFctManager.convertWidthToGrid(100);
        }
    }

    return (<Col data-name="AddressUnitFrag" data-element={data.objType} xs="auto" className={`d-flex flex-column border rounded gap-3 shadow-sm bg-white p-4 mx-auto ${frameClass} ${parentProps.parentData.customDesign?.design?.spacing ? "" : "p-0"}`} style={frameStyle}>
        <APIProvider region="FR" apiKey={mapsAPI_KEY} libraries={["geocoding"]}>
            <AddressUnit {...props}></AddressUnit>
        </APIProvider>
    </Col>);
}